<template>
<footer class="footer">
  <b-form-checkbox
      v-if="inactiveCircuitSupportedPages()"
      name="check-button"
      v-model="hideInactiveCircuits"
      switch
      @input="toggleCircuit"
  >
  </b-form-checkbox>
  <b class="font-weight-bold" v-if="inactiveCircuitSupportedPages()">Only Active Circuits</b>
  <span v-if="!sidebar">Copyright</span> © Kelvatek Limited 2019 - <b-link href="/Privacy_Policy.pdf" target="_blank">Privacy Policy</b-link> - v{{appVersion}}<span v-if="nightlyVersion"> ({{nightlyVersion}})
  <span v-if="chbVersion"><br />(chb: v{{ chbVersion }})</span>
  </span>
</footer>
</template>

<script>
import { versionService } from "@/_services";
import {mapActions} from "vuex";
import layout from "@/_store/layout.module"

export default {
  name: 'Footed',
  props: {
    sidebar: Boolean
  },
  data() {
    return {
      appVersion: process.env.VUE_APP_VERSION,
      nightlyVersion: process.env.VUE_APP_NIGHTLY_VERSION,
      chbVersion: null,
      supportedPages: [
          "DashboardPage",
          "DevicesPage",
          "FaultHistoryPage",
          "DiagnosticPage"
      ],
      hideInactiveCircuits: null
    };
  },
  methods: {
    ...mapActions("layout", [
      "toggleInactiveCircuit"
    ]),
    updateChbVersion() {
      versionService.getChbVersion()
      .then(response => {
        this.chbVersion = response.data.version.split(' ').slice(1).join(' ');
      })
    },
    toggleCircuit() {
      this.toggleInactiveCircuit(this.hideInactiveCircuits)
    },
    inactiveCircuitSupportedPages() {
      return this.supportedPages.includes(this.$route.name)
    }
  },
  mounted() {
    this.hideInactiveCircuits = layout.state.hideInactiveCircuits
    if (this.nightlyVersion) {
      this.updateChbVersion();
    }
  }
};
</script>

<style src="./Footer.scss" lang="scss" scoped/>
